import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function QualityUpdateModal({ title, onClose, id, originRows, handleView, userTypeModalOption, standardModalOption, startStandardModalOption, endStandardModalOption, passModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    quality_id: null,
    quality_name: '',
    quality_measurement_standard: 'N',
    quality_desc: '',
    quality_item_id: '',
    quality_item_name: '',
    quality_item_spec: '',
    quality_pass_start_number: '',
    quality_pass_start_standard: '',
    quality_pass_end_number: '',
    quality_pass_end_standard: '',
    quality_option1_name: '',
    quality_option1_pass_yn: '',
    quality_option2_name: '',
    quality_option2_pass_yn: '',
    quality_option3_name: '',
    quality_option3_pass_yn: '',
    quality_option4_name: '',
    quality_option4_pass_yn: '',
    quality_option5_name: '',
    quality_option5_pass_yn: '',
    quality_option6_name: '',
    quality_option6_pass_yn: '',
    quality_option_row1: 'Y',
    quality_option_row2: 'N'
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [selectUserData, setSelectUserData] = useState('');
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.reg_user_id, row.update_user_id, row.quality_user_id].includes(Number(localStorage.getItem('user_id')))
  ));
  
  const handleInitSelect = () => {
    tmpRealFiles = [];
    setUpdateUserRows([]);
    setUpdateFileRows([]);

    setInputs({
      quality_id: Number(originRows[0].quality_id),
      quality_name: originRows[0].quality_name,
      quality_measurement_standard: originRows[0].quality_measurement_standard,
      quality_desc: originRows[0].quality_desc,
      quality_item_id: typeof originRows[0].quality_item_id === 'undefined'?null:originRows[0].quality_item_id,
      quality_item_name: originRows[0].quality_item_name,
      quality_item_spec: appStore.ITEM_FULL_SPEC_MAKE(originRows[0].quality_item_spec, originRows[0].quality_item_width, originRows[0].quality_item_depth, originRows[0].quality_item_height),
      quality_pass_start_number: typeof originRows[0].quality_pass_start_number === 'undefined'?"":originRows[0].quality_pass_start_number,
      quality_pass_start_standard: typeof originRows[0].quality_pass_start_standard === 'undefined'?"":originRows[0].quality_pass_start_standard,
      quality_pass_end_number: typeof originRows[0].quality_pass_end_number === 'undefined'?"":originRows[0].quality_pass_end_number,
      quality_pass_end_standard: typeof originRows[0].quality_pass_end_standard === 'undefined'?"":originRows[0].quality_pass_end_standard,
      quality_option1_name: originRows[0].quality_option1_name,
      quality_option1_pass_yn: originRows[0].quality_option1_pass_yn,
      quality_option2_name: originRows[0].quality_option2_name,
      quality_option2_pass_yn: originRows[0].quality_option2_pass_yn,
      quality_option3_name: originRows[0].quality_option3_name,
      quality_option3_pass_yn: originRows[0].quality_option3_pass_yn,
      quality_option4_name: originRows[0].quality_option4_name,
      quality_option4_pass_yn: originRows[0].quality_option4_pass_yn,
      quality_option5_name: originRows[0].quality_option5_name,
      quality_option5_pass_yn: originRows[0].quality_option5_pass_yn,
      quality_option6_name: originRows[0].quality_option6_name,
      quality_option6_pass_yn: originRows[0].quality_option6_pass_yn,
      quality_option_row1: 'Y',
      quality_option_row2: (originRows[0].quality_option4_name !== '' || originRows[0].quality_option4_pass_yn !== '' || originRows[0].quality_option5_name !== '' || originRows[0].quality_option5_pass_yn !== '' || originRows[0].quality_option6_name !== '' || originRows[0].quality_option6_pass_yn !== '')? "Y":"N"
    });

    var userData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.quality_user_seq !== 'undefined' && item.quality_user_seq === item2.quality_user_seq;
        }) === index
      );
    });

    userData = userData.sort(function(a, b) { 
      return a.quality_user_seq < b.quality_user_seq ? -1 : a.quality_user_seq > b.quality_user_seq ? 1 : 0;
    });

    setUserRows(userData.map((item, index) => ({
      id: item.quality_user_seq,
      quality_user_id: item.quality_user_id,
      quality_user_name: item.quality_user_name,
      quality_user_dept_name: item.quality_user_dept_name,
      quality_user_position_name: item.quality_user_position_name,
      quality_user_type: item.quality_user_type,
      quality_user_bigo: item.quality_user_bigo,
      row_type: 'O',
      update_type: 'N'
    })));

    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.quality_file_id !== 'undefined' && item.quality_file_id === item2.quality_file_id;
        }) === index
      );
    });

    fileData = fileData.sort(function(a, b) { 
      return a.quality_file_id < b.quality_file_id ? -1 : a.quality_file_id > b.quality_file_id ? 1 : 0;
    });

    setFileRows(fileData.map((item, index) => ({
      id: item.quality_file_id,
      file_name_sever: item.quality_file_name_sever,
      file_size: item.quality_file_size,
      file_type: item.quality_file_type,
      file_extension: item.quality_file_extension,
      file_name: item.quality_file_name,
      file_type_name: item.quality_file_type_name,
      file_size_dp: item.quality_file_size_dp,
      reg_user_name: item.quality_file_user_name,
      reg_datetime: Moment(item.quality_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginFileRows(fileData.map((item, index) => ({
      id: item.quality_file_id,
      file_name_sever: item.quality_file_name_sever,
      file_size: item.quality_file_size,
      file_type: item.quality_file_type,
      file_extension: item.quality_file_extension,
      file_name: item.quality_file_name,
      file_type_name: item.quality_file_type_name,
      file_size_dp: item.quality_file_size_dp,
      reg_user_name: item.quality_file_user_name,
      reg_datetime: Moment(item.quality_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
    fileData.map((item, index) => 
      newFileID = (item.quality_file_id >= newFileID)?(item.quality_file_id)+1:newFileID,
    )
  };

  const handleSetting = () => {
    
    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'quality_user_id', headerName: 'quality_user_id', width: 0, headerAlign: 'center' },
      { field: 'quality_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'quality_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'quality_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'quality_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'quality_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      quality_user_id: false,
      quality_user_name: true,
      quality_user_dept_name: true,
      quality_user_position_name: true,
      quality_user_type: true,
      quality_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    quality_user_id: false,
    quality_user_name: true,
    quality_user_dept_name: true,
    quality_user_position_name: true,
    quality_user_type: true,
    quality_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    handleInitSelect();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);
  
  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        quality_user_id: '',
        quality_user_name: '',
        quality_user_dept_name: '',
        quality_user_position_name: '',
        quality_user_type: 0,
        quality_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('품목 목록')
    setSelectItemModalOpen(true);
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우    if(newRow != oldRow){
    
    if(oldRow.quality_user_id !== newRow.quality_user_id || oldRow.quality_user_type !== newRow.quality_user_type || oldRow.quality_user_bigo !== newRow.quality_user_bigo){
    
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_quality_user_id = '';
      var row_quality_user_name = '';
      var row_quality_user_type = 0;
      var row_quality_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.quality_user_id !== '' || newRow.quality_user_name !== '' || (newRow.quality_user_type !== 0 && newRow.quality_user_type !== null) || newRow.quality_user_bigo !== '' ){
          row_quality_user_id = newRow.quality_user_id;
          row_quality_user_name = newRow.quality_user_name;
          row_quality_user_type = newRow.quality_user_type;
          row_quality_user_bigo = newRow.quality_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.quality_user_id !== newRow.quality_user_id || data.quality_user_name !== newRow.quality_user_name || data.quality_user_type !== newRow.quality_user_type || data.quality_user_bigo !== newRow.quality_user_bigo )?
          (
            row_quality_user_id = data.quality_user_id,
            row_quality_user_name = data.quality_user_name,
            row_quality_user_type = data.quality_user_type,
            row_quality_user_bigo = data.quality_user_bigo
          ):""
        )
      }
      
      if(row_quality_user_id === '' && row_quality_user_name === '' && row_quality_user_bigo === '' && (row_quality_user_type === 0 || row_quality_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const userAddClick = (object) => {
    //품질 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        quality_user_id: '',
        quality_user_name: '',
        quality_user_dept_name: '',
        quality_user_position_name: '',
        quality_user_type: 0,
        quality_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        quality_user_id: object.row.quality_user_id,
        quality_user_name: object.row.quality_user_name,
        quality_user_dept_name: object.row.quality_user_dept_name,
        quality_user_position_name: object.row.quality_user_position_name,
        quality_user_type: object.row.quality_user_type,
        quality_user_bigo: object.row.quality_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //수주 담당자 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        quality_user_id: object.row.quality_user_id,
        quality_user_name: object.row.quality_user_name,
        quality_user_dept_name: object.row.quality_user_dept_name,
        quality_user_position_name: object.row.quality_user_position_name,
        quality_user_type: object.row.quality_user_type,
        quality_user_bigo: object.row.quality_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; // 수정은 초기화용과 업로드용을 따로 둔다.
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.quality_file_name_sever,
        file_size: object.row.quality_file_size,
        file_type: object.row.quality_file_type,
        file_extension: object.row.quality_file_extension,
        file_name: object.row.quality_file_name,
        file_type_name: object.row.quality_file_type_name,
        file_size_dp: object.row.quality_file_size_dp,
        reg_user_name: object.row.quality_file_user_name,
        reg_datetime: Moment(object.row.quality_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'quality_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        quality_user_id: params.row.quality_user_id,
        quality_user_name: params.row.quality_user_name,
        quality_user_dept_name: params.row.quality_user_dept_name,
        quality_user_position_name: params.row.quality_user_position_name,
        quality_user_type: params.row.quality_user_type,
        quality_user_bigo: params.row.quality_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handleAddOptionClick = (value) => {
    if(value === '1'){
      var nextInputs = {
        ...inputs,
        ['quality_option_row2']: 'Y', 
      };
      setInputs(nextInputs);
    }
  };

  const handleDeleteOptionClick = (value) => {
    if(value === '2'){
      var nextInputs = {
        ...inputs,
        ['quality_option_row2']: '', 
        ['quality_option4_name']: '',
        ['quality_option4_pass_yn']: '',
        ['quality_option5_name']: '',
        ['quality_option5_pass_yn']: '',
        ['quality_option6_name']: '',
        ['quality_option6_pass_yn']: ''
      };
      setInputs(nextInputs);
    }
  };

  const handleInputItemClick = (object) => {
    //품목
    var nextInputs = {
      ...inputs,
      ['quality_item_id']: object.id,
      ['quality_item_name']: object.item_name,
      ['quality_item_spec']: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
    };
    setInputs(nextInputs);
  };

  const handleUserClick = (object) => {
    //사용자목록 모달에서 클릭한 값으로 담당자 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].quality_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){

        processUserRowUpdate(
          {
            id : selectUserData.id,
            quality_user_id: object.id,
            quality_user_name: object.user_name,
            quality_user_dept_name: object.dept_name,
            quality_user_position_name: object.position_name,
            quality_user_type: selectUserData.quality_user_type,
            quality_user_bigo: selectUserData.quality_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            quality_user_id: selectUserData.quality_user_id,
            quality_user_name: selectUserData.quality_user_name,
            quality_user_type: selectUserData.quality_user_type,
            quality_user_dept_name: selectUserData.quality_user_dept_name,
            quality_user_position_name: selectUserData.quality_user_position_name,
            quality_user_bigo: selectUserData.quality_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';

    if(inputs.quality_name.trim() === ''){
      msg = '품질명은 필수 선택 입니다.'
    }else if(inputs.quality_item_id === '' || inputs.quality_item_id === 0 || inputs.quality_item_id === null){
      msg = '품질 품목은 필수 입력 입니다.'
    }else if(inputs.quality_measurement_standard === 'N'){
      if(inputs.quality_pass_start_number === '' && inputs.quality_pass_start_standard === '' && inputs.quality_pass_end_number === '' && inputs.quality_pass_end_standard === ''){
        msg = '품질합격기준은 필수 입력 입니다.'
      }else if(inputs.quality_pass_start_number !== '' && inputs.quality_pass_end_number !== ''){
        if(inputs.quality_pass_start_number === '' || inputs.quality_pass_end_number === ''){
          msg = '품질합격기준 숫자를 확인 바랍니다.'
        }else if(Number(inputs.quality_pass_start_number) >= Number(inputs.quality_pass_end_number)){
          msg = '품질합격기준 숫자를 확인 바랍니다.'
        }else if(inputs.quality_pass_start_standard === '' || inputs.quality_pass_end_standard === ''){
          msg = '품질합격기준 합격/불합격은 필수 입력 입니다.'
        }
      }else if(inputs.quality_pass_start_number !== '' || inputs.quality_pass_start_standard !== ''){
        if(inputs.quality_pass_start_number === ''){
          msg = '품질합격기준 숫자는 필수 입력 입니다.'
        }else if(inputs.quality_pass_start_standard === ''){
          msg = '품질합격기준 합격/불합격은 필수 입력 입니다.'
        }
      }else if(inputs.quality_pass_end_number !== '' || inputs.quality_pass_end_standard !== ''){
        if(inputs.quality_pass_end_number === ''){
          msg = '품질합격기준 숫자는 필수 입력 입니다.'
        }else if(inputs.quality_pass_end_standard === ''){
          msg = '품질합격기준 합격/불합격은 필수 입력 입니다.'
        }
      }
    }else if(inputs.quality_measurement_standard === 'O'){
      if(inputs.quality_option1_name === '' && inputs.quality_option2_name === '' 
      && inputs.quality_option3_name === '' && inputs.quality_option4_name === '' 
      && inputs.quality_option5_name === '' && inputs.quality_option6_name === ''){
        msg = '품질 옵션은 필수 입력 입니다.'
      }else if((inputs.quality_option1_name !== '' && inputs.quality_option1_pass_yn === '')
            || (inputs.quality_option2_name !== '' && inputs.quality_option2_pass_yn === '')
            || (inputs.quality_option3_name !== '' && inputs.quality_option3_pass_yn === '')
            || (inputs.quality_option4_name !== '' && inputs.quality_option4_pass_yn === '')
            || (inputs.quality_option5_name !== '' && inputs.quality_option5_pass_yn === '')
            || (inputs.quality_option6_name !== '' && inputs.quality_option6_pass_yn === '')){
        msg = '품질 옵션 합격/불합격은 입력 입니다.'
      }
    }

    // 품질담당자 검사
    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const quality_user_id = updateUserRows[i].quality_user_id;
        const quality_user_type = updateUserRows[i].quality_user_type;
        
        if(quality_user_id === 0 || quality_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(quality_user_type === 0 || quality_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">품질 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Quality/Reg", {inputs, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        
        if(response.status === 200){

          if(updateFileRows.length > 0) {

            var selectID = inputs.quality_id;
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Quality');
            formData.append('type', 'Update');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              Swal.fire({
                title: '품질 수정 완료',
                text: '정상적으로 품질이 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }).catch(error => {
              appStore.capture();
            });

          }else{

            Swal.fire({
              title: '품질 수정 완료',
              text: '정상적으로 품질이 수정 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleView();
            });
            
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="품질 정보" value="1" />
                <Tab label="품질 담당자" value="2" />
                <Tab label="품질 파일" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
            <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="품질명" value={inputs.quality_name} name="quality_name" onChange={(e) => onChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질입력기준<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="품질입력기준" value={standardModalOption.filter(function (option) { return option.value === inputs.quality_measurement_standard;  })} onChange={(e) => onSelectChange('quality_measurement_standard',e.value)} options={standardModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.quality_item_name} name="quality_item_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '260px', backgroundColor: '#EFEFEF4D', marginRight: '15px', cursor: 'pointer' }} onClick={(e) => onClick(e) }  readOnly />
                          <input type="text" placeholder="규격" value={inputs.quality_item_spec} name="quality_item_spec" onChange={(e) => onChange(e) } style={{ float: 'left', width: '470px', backgroundColor: '#EFEFEF4D' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  {(inputs.quality_measurement_standard === 'N')?
                  <>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">품질합격기준<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '240px', marginRight: '30px' } }>
                          <input type="number" placeholder="숫자" value={inputs.quality_pass_start_number} name="quality_pass_start_number" onChange={(e) => onChange(e) } style={{ float: 'left', width: '100px', marginRight: '15px' }} />
                          <Select className="modal_filed_input_select" placeholder="기준" value={startStandardModalOption.filter(function (option) { return option.value === inputs.quality_pass_start_standard;  })}  onChange={(e) => onSelectChange('quality_pass_start_standard',e.value)} options={startStandardModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '240px' } }>
                          <input type="number" placeholder="숫자" value={inputs.quality_pass_end_number} name="quality_pass_end_number" onChange={(e) => onChange(e) } style={{ float: 'left', width: '100px', marginRight: '15px' }} />
                          <Select className="modal_filed_input_select" placeholder="기준" value={endStandardModalOption.filter(function (option) { return option.value === inputs.quality_pass_end_standard;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_pass_end_standard',e.value)} options={endStandardModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  </>
                  :
                  (inputs.quality_measurement_standard === 'O')?
                  <>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed" id="option_1">
                        <div className="modal_filed_title">품질옵션<span className="essential">*</span></div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '244px', paddingRight: '20px'} }>
                          <input type="text" placeholder="옵션1" value={inputs.quality_option1_name} name="quality_option1_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션1" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option1_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option1_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '244px', paddingRight: '20px'} }>
                          <input type="text" placeholder="옵션2" value={inputs.quality_option2_name} name="quality_option2_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션2" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option2_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option2_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '240px'} }>
                          <input type="text" placeholder="옵션3" value={inputs.quality_option3_name} name="quality_option3_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션3" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option3_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option3_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        {inputs.quality_option_row2 === 'Y'?
                        <></>
                        :
                        <>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '30px'} }>
                          <AddIcon color="secondary" style={ { paddingTop: '5px', fontSize: '35px', cursor: 'pointer' } } onClick={() => {handleAddOptionClick('1')}} />
                        </div>
                        </>
                        }
                      </div>
                    </td>
                  </tr>
                  </>:<></>}
                  { inputs.quality_option_row2 === 'Y'?
                  <>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed" id="option_2">
                        <div className="modal_filed_title"></div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '244px', paddingRight: '20px'} }>
                          <input type="text" placeholder="옵션4" value={inputs.quality_option4_name} name="quality_option4_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션4" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option4_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option4_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '244px', paddingRight: '20px'} }>
                          <input type="text" placeholder="옵션5" value={inputs.quality_option5_name} name="quality_option5_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션5" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option5_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option5_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '240px'} }>
                          <input type="text" placeholder="옵션6" value={inputs.quality_option6_name} name="quality_option6_name" onChange={(e) => onChange(e) } style={{ float: 'left', width: '110px', marginRight: '10px' }} />
                          <Select className="modal_filed_input_select" placeholder="옵션6" value={passModalOption.filter(function (option) { return option.value === inputs.quality_option6_pass_yn;  })} style={{ float: 'left', width: '50px' }} onChange={(e) => onSelectChange('quality_option6_pass_yn',e.value)} options={passModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                        <div className="modal_filed_input" style={ { display: 'flex',  width: '30px'} }>
                          <DeleteIcon color="error" style={ { paddingTop: '5px', fontSize: '35px', cursor: 'pointer' } } onClick={() => {handleDeleteOptionClick('2')}} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  </>
                  :
                  <></>}
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="비고" value={inputs.quality_desc} name="quality_desc" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>            
                    {updateFlag &&
                    <div className="modal_button">
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                    </div> }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          upperPartnerId={''}
          nowIOType={'O'}
          handleInputItemClick={handleInputItemClick}
          />)}
    </PCModal>
  );
}

export default QualityUpdateModal;